export default __webpack_public_path__ + "static/media/action.d7b4935c.webp";